import { render, staticRenderFns } from "./estado_declaracion.vue?vue&type=template&id=62cbaf0a"
import script from "./estado_declaracion.js?vue&type=script&lang=js&external"
export * from "./estado_declaracion.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports